// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: wzNiXPwRag
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "./plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicStandardButton.module.css"; // plasmic-import: wzNiXPwRag/css

createPlasmicElementProxy;

export const PlasmicStandardButton__VariantProps = new Array("type");

export const PlasmicStandardButton__ArgProps = new Array();

const $$ = {};

function PlasmicStandardButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <button
      data-plasmic-name={"closeBigBtn"}
      data-plasmic-override={overrides.closeBigBtn}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.__wab_text,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.closeBigBtn,
        { [sty.closeBigBtntype_success]: hasVariant($state, "type", "success") }
      )}
      ref={ref => {
        $refs["closeBigBtn"] = ref;
      }}
    >
      {"Close"}
    </button>
  );
}

const PlasmicDescendants = {
  closeBigBtn: ["closeBigBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicStandardButton__ArgProps,
          internalVariantPropNames: PlasmicStandardButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicStandardButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "closeBigBtn") {
    func.displayName = "PlasmicStandardButton";
  } else {
    func.displayName = `PlasmicStandardButton.${nodeName}`;
  }
  return func;
}

export const PlasmicStandardButton = Object.assign(
  // Top-level PlasmicStandardButton renders the root element
  makeNodeComponent("closeBigBtn"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicStandardButton
    internalVariantProps: PlasmicStandardButton__VariantProps,
    internalArgProps: PlasmicStandardButton__ArgProps
  }
);

export default PlasmicStandardButton;
/* prettier-ignore-end */
